export const alphabeticallySort = (a, b) => a.name.localeCompare(b.name);
